if (!customElements.get('wishlist-landing')) {
    class ComponentWishlistLanding extends HTMLElement {
        // todo only show share if there is a lid
        constructor() {
            super();
            this.mode = this.dataset.mode;
            this.swat = null;
            this.lid = null;
            this.personalLid = null;
            this.html = document.createElement('div');
            this.templateContent = this.querySelector('template').content.cloneNode(true);
            this.templateRootElement = this.templateContent.querySelector('.products-carousel-root');
            this.itemsContent = this.templateRootElement.querySelector('.keen-slider, .grid');
            this.noResults = this.dataset.noResults;
            this.removeLabel = this.dataset.removeLabel;
            
            this.addEventListener('wishlistRemove', this.removeFromWishlist.bind(this))
        }

        init (swat) {
            this.swat = swat;
            if (this.mode == 'shared') {
                const params = new URLSearchParams(window.location.search);
                const lid = params.get('hkey')
                this.lid = lid;
            }
            this.renderWishlist();
        }

        removeFromWishlist(event) {
            if (!this.swat || !this.personalLid) return;

            const { empi, epi, du } = event.detail;

            const onSuccess = (deletedProduct) => {
                this.renderWishlist()
            }
            const onError = (error) => {
                console.error("Error while deleting the Product:", error);
            }
            const deletePayload = { empi, epi, du };
            this.swat.deleteFromList(this.personalLid, deletePayload, onSuccess, onError)
        }

        flattenLists(lists) {
            return lists
                .flatMap(list => Array.isArray(list.listcontents) ? list.listcontents : [])
                .map(product => ({ ...product, handle: product.du?.split('/products/')[1].split('?')[0] || null }))
        }

        loadPersonalWishlist() {
            const onSuccess = (lists) => {
                if (!Array.isArray(lists) || lists.length === 0) {
                    return this.showEmpty();
                }

                const defaultList = lists.find(
                    list => list?.lname?.trim()?.toLowerCase() === 'my wishlist'
                ) || lists[0];

                this.personalLid = defaultList.lid;

                const allProducts = this.flattenLists([defaultList]);
                const username = this.getUsername([defaultList]);

                if(allProducts.length>0){
                    this.showProducts(allProducts, username);
                }else{
                    this.showEmpty();
                }
            }
            const onError = (error) => {
                console.log("Error while fetching all Lists", error);
                this.showEmpty()
            };
            this.swat.fetchLists({
                callbackFn: onSuccess,
                errorFn: onError
            });
        }

        loadPublicWishlist() {
            if (!this.lid) {
                this.showEmpty()
                return;    
            }

            const onSuccess = (listDetails) => {
                if (listDetails && listDetails.list) {
                    const allProducts = this.flattenLists([listDetails.list])
                    this.showProducts(allProducts, this.getUsername([listDetails.list]))
                }
            }

            const onError = (error) => {
                console.log("Error while fetching List details", error);
                this.showEmpty()
            }

            this.swat.fetchListDetails({ lid: this.lid }, onSuccess, onError);
        }

        renderWishlist() {
            if (!this.swat) return;

            if (this.mode === 'personal') {
                this.loadPersonalWishlist()
            } else if (this.mode == 'shared') {
                this.loadPublicWishlist();
            }
        }

        showProducts(allProducts, username) {
            var handlesUrls = allProducts.map(product => {
                return {
                    handle: product.handle,
                    url: routes.products_url + '/' + product.handle + '?sections=product_card_ajax',
                    ...product
                }
            });
            var urls = handlesUrls.map(x => {
                return x.url
            });
            $s.getDataFromUrls(urls).then(data => {
                var html = '';
                handlesUrls.forEach(x => {
                    var handle = x.handle;
                    var url = x.url;
                    var parser = new DOMParser();
                    if (data[url]) {
                        try {

                            var cardDataset = `data-du="${x.du}" data-empi="${x.empi}" data-epi="${x.epi}" data-vi="${x.vi}"`

                            var ajaxHtml = JSON.parse(data[url]).product_card_ajax;
                            var itemDoc = parser.parseFromString(ajaxHtml, 'text/html');
                            var itemHTML = itemDoc.querySelector('.product-card-ajax').innerHTML;
                            itemHTML = itemHTML.replace('<product-card ', `<product-card ${cardDataset}`)
                            if (itemHTML) {
                                html += itemHTML;
                            } else {
                                this.removeHandle(handle);
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    } else {
                        this.removeHandle(handle);
                    }
                });
                if (html != '') {
                    html = this.itemsContent.classList.contains('grid') ? html.replaceAll('keen-slider-slide', 'grid-item') : html;
                    this.style.display = ''; //removes 'display: none'
                    this.itemsContent.innerHTML = html;
                    this.itemsContent.querySelectorAll('.product-card').forEach(card => {
                        if (this.dataset.cardsColorScheme) {
                            card.classList.add('scheme', ...this.dataset.cardsColorScheme.split(' '));
                        }
                        if (this.dataset.cardsColorScheme == this.dataset.contentColorScheme) {
                            card.classList.add('same-scheme-true');
                            card.classList.remove('same-scheme-false');
                        } else {
                            card.classList.add('same-scheme-false');
                            card.classList.remove('same-scheme-true');
                        }
                        // Adding variant next to title to tell apart added products
                        if (card.dataset.vi) {
                            card.querySelector('.title').innerHTML = `${card.querySelector('.title').innerHTML} | ${card.dataset.vi}`
                        }
                        // Adding remove button, fires custom event to be handled by swat
                        if (this.mode == 'personal') {
                            var btnEl = document.createElement('button');
                            btnEl.innerHTML = this.removeLabel;
                            btnEl.classList.add('btn', 'v2')
                            card.appendChild(btnEl)
                            btnEl.addEventListener('click', event => {
                                event.preventDefault()
                                var parentCard = event.currentTarget.closest('product-card');
                                if (!parentCard) return;
                                this.dispatchEvent(new CustomEvent('wishlistRemove', {
                                    detail: {
                                        du: parentCard.dataset.du,
                                        empi: parentCard.dataset.empi,
                                        epi: parentCard.dataset.epi
                                    }
                                }))
                            })
                        }
                        
                    });
                    this.insertAdjacentElement('beforeend', this.templateRootElement);
                    this.showShareButton(false)
                    this.initShare();
                    if (this.mode === 'shared') {
                        this.querySelector('.head .title').innerHTML = `${username ? `${username}'s ` : ''}${this.querySelector('.head .title').innerHTML}`
                    }
                    if (this.mode === 'personal' && this.personalLid) 
                        this.showShareButton()
                }
            });
        }

        showShareButton(show = true) {
            let shareButtonEl = this.querySelector('.btn-wrap > .btn');
            if (shareButtonEl) {
                if (show) {
                    shareButtonEl.classList.remove('hide')
                } else {
                    shareButtonEl.classList.add('hide')
                }
            }
        }

        showEmpty() {
            this.itemsContent.innerHTML = `<div class="container wishlist-empty">${this.noResults}</div>`
            this.insertAdjacentElement('beforeend', this.templateRootElement);
            this.initShare()
            if (this.mode === 'personal') 
                this.showShareButton(false)
        }

        getUsername (lists) {
            if (lists.length < 1) return;
            let list = lists[0];
            let uby = list.uby;
            if (!uby) return;
            let username = uby.indexOf('@') > -1 ? uby.split('@')[0] : uby;
            return username;
        }

        initShare() {
            if (this.mode != 'personal') return;
            this.btnShare = this.querySelector('.btn-wrap .btn')
            if (this.btnShare)
                this.btnShare.addEventListener('click', this.onShareClick.bind(this))
        }

        onShareClick (event) {
            event.preventDefault();
            this.shareList();
        }

        shareList () {
            if (!this.swat || !this.personalLid) return;

            this.swat.markListPublic(this.personalLid, (response) => {
                this.swat.generateSharedListURL(response.lid, (data, url) => this.swatURLSuccess(data, url, this), this.swatShareError);
            }, this.swatShareError);
        }

        swatURLSuccess(data, url, component) {
            let modalComponent = $s.openModal(document.querySelector('#popup-share')?.innerHTML, 'popup-share');
            this.initShareModal(modalComponent.modal, data)
        }
        
        swatShareError(err) {
            console.log('Error sharing list', err)
        }

        initShareModal(modal, url) {
            let shareTextEl = modal.querySelector('.share-url');
            shareTextEl.innerHTML = url;

            modal.querySelector('.btn-facebook').addEventListener('click', event => {
                event.preventDefault()
                this.swat.shareWishlistSocial(
                    null,
                    `https://www.facebook.com/sharer.php?u=${url}&t=My Picks!`,
                    "facebook",
                    "My picks!",
                    function(err) {
                        console.log(data)
                    }
                );
            })

            modal.querySelector('.btn-twitter').addEventListener('click', event => {
                event.preventDefault()
                this.swat.shareWishlistSocial(
                    null,
                    `https://www.twitter.com/intent/tweet?url=${url}&text=My Picks!`,
                    "twitter",
                    "My picks!",
                    function(err) {
                        console.log(data)
                    }
                );
            })

            modal.querySelector('.btn-copy').addEventListener('click', event => {
                event.preventDefault();
                let btnEl = event.currentTarget
                navigator.clipboard.writeText(url)
                    .then(() => {
                        btnEl.querySelector('span').innerHTML = btnEl.dataset.copiedLabel;
                        setTimeout(() => btnEl.querySelector('span').innerHTML = btnEl.dataset.copyLabel, 1000)
                    })
                    .catch(err => {
                        console.error("Failed to copy: ", err);
                    });
            })

        }
    }
    customElements.define('wishlist-landing', ComponentWishlistLanding);
}